import { Dropdown, Icon } from 'react-materialize'
import { Username } from './Elements'

type UserDropdownProps = {
  username: string
}

const UserDropdown: React.FC<UserDropdownProps> = ({ username, children }) => (
  <Dropdown
    id="NavDropdown"
    options={{
      alignment: 'right',
      constrainWidth: false,
      coverTrigger: false,
      outDuration: 150,
    }}
    trigger={
      <Username>
        {username}
        <Icon>arrow_drop_down</Icon>
      </Username>
    }
  >
    {children}
  </Dropdown>
)

export default UserDropdown
